const TEMPLATE_META_PREFIX = '<!--AOT_TEMPLATE_META:';
const TEMPLATE_META_SUFFIX = '-->';

const toBase64 = (value) => {
  try {
    return btoa(unescape(encodeURIComponent(String(value || ''))));
  } catch (_) {
    return '';
  }
};

const fromBase64 = (value) => {
  try {
    return decodeURIComponent(escape(atob(String(value || ''))));
  } catch (_) {
    return '';
  }
};

export const stripTemplateMeta = (content) => {
  const source = String(content || '');
  const pattern = /<!--AOT_TEMPLATE_META:[\s\S]*?-->\s*/i;
  return source.replace(pattern, '');
};

export const extractTemplateMeta = (content) => {
  const source = String(content || '');
  const match = source.match(/<!--AOT_TEMPLATE_META:([\s\S]*?)-->/i);
  if (!match) {
    return {
      content: source,
      header_content: '',
      footer_content: '',
      header_gap_px: 12,
      footer_gap_px: 12,
      hasMeta: false,
    };
  }

  const encoded = String(match[1] || '').trim();
  const decoded = fromBase64(encoded);
  let parsed = null;
  try {
    parsed = decoded ? JSON.parse(decoded) : null;
  } catch (_) {
    parsed = null;
  }

  const body = source.replace(match[0], '');
  return {
    content: body,
    header_content: String(parsed?.header_content || ''),
    footer_content: String(parsed?.footer_content || ''),
    header_gap_px: Number.isFinite(Number(parsed?.header_gap_px)) ? Math.max(0, Number(parsed.header_gap_px)) : 12,
    footer_gap_px: Number.isFinite(Number(parsed?.footer_gap_px)) ? Math.max(0, Number(parsed.footer_gap_px)) : 12,
    hasMeta: !!parsed,
  };
};

export const mergeTemplateMeta = (content, headerContent, footerContent, headerGapPx = 12, footerGapPx = 12) => {
  const body = stripTemplateMeta(content);
  const meta = {
    header_content: String(headerContent || ''),
    footer_content: String(footerContent || ''),
    header_gap_px: Math.max(0, Number(headerGapPx) || 0),
    footer_gap_px: Math.max(0, Number(footerGapPx) || 0),
  };

  const hasAnyMeta = !!(meta.header_content || meta.footer_content);
  if (!hasAnyMeta) return body;

  const encoded = toBase64(JSON.stringify(meta));
  if (!encoded) return body;
  return `${TEMPLATE_META_PREFIX}${encoded}${TEMPLATE_META_SUFFIX}${body}`;
};

export const hasMeaningfulHtml = (value) => {
  const source = String(value || '');
  if (!source) return false;
  if (/\{\{[^{}]+\}\}/.test(source)) return true;
  const withoutTags = source
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<\/?[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();
  return withoutTags.length > 0;
};

export const pickHeaderFooterValue = (directValue, metaValue, fallbackValue = '') => {
  const direct = directValue == null ? '' : String(directValue);
  const meta = metaValue == null ? '' : String(metaValue);
  if (hasMeaningfulHtml(direct)) return direct;
  if (hasMeaningfulHtml(meta)) return meta;
  return fallbackValue == null ? '' : String(fallbackValue);
};
